import { ControlledSelectOption } from "ui";

export enum AppStatusEnum {
  enabled = "active",
  disabled = "disabled",
}

export const appStatusEnumValues = Object.values(AppStatusEnum);
export const appStatusEnumLabelMap: Record<AppStatusEnum, string> = {
  [AppStatusEnum.enabled]: "Active",
  [AppStatusEnum.disabled]: "Disabled",
};

export const appStatusEnumSelectOptions: ControlledSelectOption[] = [
  {
    label: "Active",
    value: AppStatusEnum.enabled,
  },
  {
    label: "Disabled",
    value: AppStatusEnum.disabled,
  },
];
